import React from 'react';
import { ChecklistData } from '../types';
import { Stack, Dropdown, IDropdownOption } from '@fluentui/react';
import LabeledTextField from '../common/LabeledTextField';
import IvicosStrings from 'kits/language/stringKit';

const operatingSystems: IDropdownOption[] = [
    { key: 'windows', text: 'Windows' },
    { key: 'macos', text: 'macOS' },
    { key: 'linux', text: 'Linux' },
    { key: IvicosStrings.webRTCDiagnosticsBrowserOther, text: IvicosStrings.webRTCDiagnosticsBrowserOther }
];

interface Props {
    checklistData: ChecklistData;
    setChecklistData: React.Dispatch<React.SetStateAction<ChecklistData>>;
}

const AdditionalInfo: React.FC<Props> = ({ checklistData, setChecklistData }) => {
    const update = (key: keyof ChecklistData, val: string) => setChecklistData((prev) => ({ ...prev, [key]: val }));

    return (
        <Stack tokens={{ childrenGap: 15 }}>
            <Stack style={{ width: '50%' }}>
                <LabeledTextField
                    label={IvicosStrings.webRTCDiagnosticsAdditionalIssueStartDate}
                    value={checklistData.issueStartDate}
                    onChange={(val) => update('issueStartDate', val)}
                />
            </Stack>

            <Stack style={{ width: '50%' }}>
                <LabeledTextField
                    label={IvicosStrings.webRTCDiagnosticsAdditionalIssueFrequency}
                    value={checklistData.issueFrequency}
                    onChange={(val) => update('issueFrequency', val)}
                />
            </Stack>

            <Stack style={{ width: '50%' }}>
                <LabeledTextField
                    label={IvicosStrings.webRTCDiagnosticsAdditionalIssueOtherParticipants}
                    value={checklistData.otherParticipantsIssue}
                    onChange={(val) => update('otherParticipantsIssue', val)}
                />
            </Stack>

            <Stack style={{ width: '50%' }}>
                <LabeledTextField
                    label={IvicosStrings.webRTCDiagnosticsAdditionalIssueAnyOtherIssues}
                    multiline
                    rows={4}
                    value={checklistData.additionalDetails}
                    onChange={(val) => update('additionalDetails', val)}
                />

                <Dropdown
                    label={IvicosStrings.webRTCDiagnosticsOperatingSystemLabel}
                    options={operatingSystems}
                    selectedKey={checklistData.operatingSystem}
                    onChange={(_, option) => option && update('operatingSystem', option.key as string)}
                    styles={{ root: { width: 200, marginTop: 10 } }}
                />
            </Stack>
        </Stack>
    );
};

export default AdditionalInfo;
